import api from './../api'
import { decrypt } from '../../pages/private/patients/helper'

export default {
    namespaced: true,
    state: {
        codeBooks: {}
    },
    getters: {
        get(state) {
            return function (codeBook) {
                return state.codeBooks[codeBook] === undefined ? [] : state.codeBooks[codeBook];
            };
        }
    },
    actions: {
        load(store, codebooks) {
            return new Promise((resolve, reject) => {
                api.get('code-book/list/' + codebooks).then(response => {
                    const { data } = response
                    if(data.hasOwnProperty('patient')) {
                      let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
                      data.patient = data.patient.map(patient => decrypt(store,loggedUser,patient));
                    }
                    store.commit('setCodeBooks', data);
                    resolve(data);
                }).catch(error => {
                    // todo: catch error :)
                    reject(error.response);
                });
            });
        },
        loadEpi(store, applicationId) {
          return new Promise((resolve, reject) => {
            api.get('code-book/list/epicrisis?applicationId=' + applicationId).then(response => {
              store.commit('setCodeBooks', response.data);
              resolve(response.data);
            }).catch(error => {
              // todo: catch error :)
              reject(error.response);
            });
          });
        },
        patientTemplates(store, data) {
            return new Promise((resolve, reject) => {
                api.get('code-book/patient-templates/' + data.id + '/' + data.type).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
    },
    mutations: {
        setCodeBooks(state, data) {
            Object.keys(data).forEach(item => {
                state.codeBooks[item] = data[item];
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/codeBook.js